import { styled } from "common/components";

export const ViewsContainer = styled("div")(({ theme }) => ({
  display: "grid",
  rowGap: theme.spacing(1),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));
